// @ts-nocheck
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import ProductShipsFrom, { ProductShipsFromStyles } from "@store/Library/Components/ProductShipsFrom";

import React, { FC } from "react";

interface OwnProps {}

type Props = OwnProps & WidgetProps;

export const productDetailsAdditionInfosStyles: ProductShipsFromStyles = {};

const styles = productDetailsAdditionInfosStyles;

const ProductDetailsShipsFrom: FC<Props> = () => {
    return <ProductShipsFrom extendedStyles={styles} />;
};

const widgetModule: WidgetModule = {
    component: ProductDetailsShipsFrom,
    definition: {
        group: "Product Details",
        displayName: "Product Details Additionnal Informations",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
